import React from 'react';
import Typography from '@visa/vds/typography';
import { DateHelper } from "../../../../_helpers/DateHelper";
import MCSReadonlyField from '../../../../components/MCSReadonlyField';
import MCSSpace from '../../../../components/MCSSpace';

const BillingReviewInfo = (props) => {
    const summary = props.billingSummary;
    if (!summary) return <></>;

    let createdByText = summary.createdBy;
    if (summary.createdByUser) createdByText = summary.createdByUser.fullName;

    if (summary.approved) {
        return (
            <>
                <Typography tag="h4">Billing for {summary.fileVersion} has been approved.</Typography>
                <MCSReadonlyField label={"Approved By"} text={createdByText} />
                <MCSReadonlyField label={"Approved On"} text={DateHelper.ToFormattedDate(summary.createdOn)} />
                <MCSSpace />
                <Typography tag="h4">Billing items included for {summary.fileVersion} file:</Typography>
            </>
        );
    }

    if (!summary.allowApprove) {
        return (
            <>
                <Typography tag="h4">Billing for {summary.fileVersion} (current month) can be approved between {summary.cutOffDate} and the last day of the month.</Typography>
                <Typography tag="h4">Preview items will be included in {summary.fileVersion} file:</Typography>
            </>
        );
    }

    // allowApprove == true && approved == false
    return (
        <>
            <Typography tag="h4">Billing for {summary.fileVersion} (current month) can be approved now.</Typography>
            <Typography tag="h4">Please review and approve following items included in {summary.fileVersion} file:</Typography>
        </>
    );
}

export default BillingReviewInfo;
